var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerspective2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 299,
    viewBox: "0 0 14 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 299C6.26801 299 0 292.732 0 285V14C0 6.26801 6.26801 0 14 0V299Z",
    fill: "#0F9D56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerspective2);
export default __webpack_public_path__ + "static/media/Perspective2.94a17fd80888fc11e07cfe052c2d0bcb.svg";
export { ForwardRef as ReactComponent };